import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IMitarbeiterResponseRow } from 'fa-kt.types';
import { AuthService } from 'pbc.angular';
import { BehaviorSubject } from 'rxjs';
import { MitarbeiterService } from '../service';

@Component({
  selector: 'fa-kt-mitarbeiter-list',
  templateUrl: './mitarbeiter-list.component.html',
  styleUrls: ['./mitarbeiter-list.component.css'],
})
export class MitarbeiterListComponent {
  $loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  @Input() set loading(loading: boolean) {
    this.$loading.next(this.$loading.getValue() || loading);
  }
  @Input() height = 'calc(100vh - 324px)';

  @Output() select: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    public auth: AuthService,
    public mitarbeiter: MitarbeiterService,
  ) {}

  public set(mitarbeiter: IMitarbeiterResponseRow) {
    /* << custom    */
    this.select.emit(mitarbeiter.mitarbeiter.id);
    /*    custom >> */
  }
}
